export function Button({ children, onClick, className = "", type = "button" }) {
  const baseStyles = "px-4 py-2 rounded-md text-white transition-colors duration-300";
  const defaultBg = "bg-black hover:bg-gray-800";

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseStyles} ${className || defaultBg}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
